$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  let language = $("body").attr("lang");
  const menuProducts = [];

  $(document).on("change", "#is_volume", function () {
    if ($(this).prop("checked")) {
      $("#volume").prop("required", true);
      $("#volume").prop("type", "number");
    } else {
      $("#volume").removeAttr("required");
      $("#volume").prop("type", "hidden");
    }
  });
  $(document).on(
    "change",
    "input[name='picture'] , input[name^='customer-picture-']",
    function () {
      let file = this.files[0];
      $("#pictureAlert").html("");
      if (file) {
        let maxSize = 1 * 1024 * 1024;

        if (file.size > maxSize) {
          alert("⚠️ Filstørrelsen er for stor! Maksimal størrelse er 1 MB");

          $(this).val("");
          return;
        }
      }
    }
  );
  if (p == "organizer_event_ticket_category" && a == "update") {
    let previousMenuProductTotal = 0;
    let isRemovingPreviousMenuProduct = false;
    let existingProductPriceForMenuProduct = 0;
    let menuTotalProductPrice = 0;
    let mva = $("#vat_code").children("option:selected").text();
    let degreeOfCoverage = formattedValueForNumberInput(
      $("#degree_of_coverage").val()
    );
    let coverageOfContribution = formattedValueForNumberInput(
      $("#coverage_contribution").val()
    );
    let productPrice = formattedValueForNumberInput(
      $("#ticket_price_ex_vat").val()
    );
    const existingOldProductPrice = parseFloat(
      $("#ticket_price_ex_vat")
        .attr("data-old-value")
        .toString()
        .replace(",", ".")
    );
    let priceExMva = formattedValueForNumberInput(
      $("#price-ex-mva-value").val()
    );
    let priceIncMva = formattedValueForNumberInput(
      $("#price-inc-mva-value").val()
    );

    // alternative_prices
    let alterDegreeOfCoverage = formattedValueForNumberInput(
      $("#alter_degree_of_coverage").val()
    );

    let alterCoverageOfContribution = formattedValueForNumberInput(
      $("#alter_coverage_contribution").val()
    );

    let alterProductPrice = formattedValueForNumberInput(
      $("#ticket_alter_price_ex_vat").val()
    );

    let alterMva = $("#alter_vat_code").children("option:selected").text();

    let alterPriceOutExMva = formattedValueForNumberInput(
      $("#alter_price_out_ex_mva").val()
    );

    let alterPriceOutIncMva = formattedValueForNumberInput(
      $("#alter_ticket_price_out_inc_mva").val()
    );

    //end of alt_prices

    let event_ticket_category_update_ajax_lock = false;
    let isProductTotalSum = false;
    //Initial Base Price
    if (!$("#is_product_total_sum").is(":checked")) {
      // This new price becomes the new base price
      window.detectedBasePrice = parseFloat(productPrice);
      $(".amount-input").addClass("disabled").prop("disabled", true);
    }

    function floorTo2(num) {
      return Math.floor(num * 100) / 100;
    }

    $(document).on("click", "#is_product_total_sum", function () {
      isProductTotalSum = $("#is_product_total_sum").is(":checked");
      const removeButtons = $(".remove-menu-product");
      const amountInputs = $(".amount-input");

      const existingProductPriceExVat = $("#price-ex-mva-value").attr(
        "data-old-value"
      );
      const existingProductPriceIncVat = $("#price-inc-mva-value").attr(
        "data-old-value"
      );
      const existingProductDB = $("#coverage_contribution").attr(
        "data-old-value"
      );
      const existingProductDG = $("#degree_of_coverage").attr("data-old-value");
      if (isProductTotalSum) {
        removeButtons.removeClass("disabled").prop("disabled", false);
        amountInputs.removeClass("disabled").prop("disabled", false);
        previousMenuProductTotal = 0;
        calculateMenuProductTotalSum(menuProducts);
      } else {
        removeButtons.addClass("disabled").prop("disabled", true);
        amountInputs.addClass("disabled").prop("disabled", true);
        // Pass a callback function to handle the result
        calculateMenuProductTotalSum(
          menuProducts,
          "get_current_total_menu_product_price",
          function (totalPrice) {
            menuTotalProductPrice = totalPrice;
            productPrice = productPrice - menuTotalProductPrice;
            productPrice = productPrice.toFixed(2).replace(".", ",");
            $("#ticket_price_ex_vat").val(productPrice || "");
            $("#price-ex-mva-value").val(existingProductPriceExVat || "");
            $("#price-inc-mva-value").val(existingProductPriceIncVat || "");
            $("#degree_of_coverage").val(existingProductDG || "");
            $("#coverage_contribution").val(existingProductDB || "");
            if (
              degreeOfCoverage === null ||
              degreeOfCoverage === undefined ||
              degreeOfCoverage === ""
            ) {
              degreeOfCoverage = 0;
            }
            $("#degree_of_coverage").trigger("change");
            previousMenuProductTotal = 0;
          }
        );
      }
    });

    $(document).on("blur", "#product-sku-input", function (e) {
      e.preventDefault();
      const encodedData = $("#existing_product_number").attr(
        "data-product-number-list"
      );
      const existingNumberList = JSON.parse(atob(encodedData));
      const newValue = $(this).val();
      const oldValue = $(this).attr("data-old-value");
      const filteredexistingNumbers = existingNumberList.filter(
        (number) => number !== oldValue
      );

      if (filteredexistingNumbers.includes(newValue)) {
        alert("varenummer finnes allerede!");
        $(this).val(oldValue);
        $(this).focus();
        return;
      }
    });

    $(document).on("change", "#ticket_price_ex_vat", function (e) {
      e.preventDefault();
      productPrice = formattedValueForNumberInput($(this).val());
      // This new price becomes the new base price
      window.detectedBasePrice = parseFloat(productPrice);
      const isProductTotalSum = $("#is_product_total_sum").is(":checked");
      const payload = {
        field: "ticket_price_ex_vat",
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
          // After updating the input values, if checkbox is checked and we have menu products,
          // we need to add the menu products to this new base price
          if (isProductTotalSum && menuProducts.length > 0) {
            console.log(
              "Checkbox is checked and we have menu products, recalculating total"
            );

            // Reset the tracking and recalculate
            previousMenuProductTotal = 0;
            calculateMenuProductTotalSum(menuProducts);
          }
        })
        .fail(function (data) {
          console.log(data);
          if (
            productPrice == 0 &&
            isProductTotalSum &&
            menuProducts.length > 0
          ) {
            console.log(
              "Checkbox is checked and we have menu products, recalculating total with zero" +
              productPrice
            );

            // Reset the tracking and recalculate
            previousMenuProductTotal = 0;
            calculateMenuProductTotalSum(menuProducts);
          }
        });
    });

    $(document).on("change", "#degree_of_coverage", function (e) {
      e.preventDefault();

      degreeOfCoverage = formattedValueForNumberInput($(this).val());
      const payload = {
        field: "degree_of_coverage",
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on("change", "#coverage_contribution", function (e) {
      e.preventDefault();
      coverageOfContribution = formattedValueForNumberInput($(this).val());
      const payload = {
        field: "coverage_contribution",
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on("change", "#price-ex-mva-value", function (e) {
      e.preventDefault();
      priceExMva = formattedValueForNumberInput($(this).val());
      const payload = {
        field: "price_ex_mva_value",
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on("change", "#price-inc-mva-value", function (e) {
      e.preventDefault();
      priceIncMva = formattedValueForNumberInput($(this).val());
      const payload = {
        field: "price_inc_mva_value",
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on("change", "#vat_code", function (e) {
      e.preventDefault();
      mva = $(this).children("option:selected").text();
      const payload = {
        field: "price_ex_mva_value",
        productPrice,
        priceExMva,
        priceIncMva,
        degreeOfCoverage,
        coverageOfContribution,
        mva: parseInt(mva),
      };

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    // alternative Prices

    $(document).on("change", "#ticket_alter_price_ex_vat", function (e) {
      e.preventDefault();

      const alterProductPrice = formattedValueForNumberInput($(this).val());

      // Make sure these variables are defined or replace them with actual values
      const payload = {
        field: "ticket_alter_price_ex_vat",
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      // console.log("Payload being sent:", payload);

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-alter-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          // console.log("Response from API:", data);
          updateAlterInputValues(data);
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.error(" API Error:", textStatus, errorThrown);
          console.log("Response Text:", jqXHR.responseText);
        });
    });

    $(document).on("change", "#alter_degree_of_coverage", function (e) {
      e.preventDefault();

      alterDegreeOfCoverage = formattedValueForNumberInput($(this).val());
      const payload = {
        field: "alter_degree_of_coverage",
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-alter-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateAlterInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on("change", "#alter_coverage_contribution", function (e) {
      e.preventDefault();
      alterCoverageOfContribution = formattedValueForNumberInput($(this).val());
      const payload = {
        field: "alter_coverage_contribution",
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-alter-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateAlterInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on("change", "#alter_price_out_ex_mva", function (e) {
      e.preventDefault();
      alterPriceOutExMva = formattedValueForNumberInput($(this).val());
      const payload = {
        field: "alter_price_out_ex_mva",
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-alter-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateAlterInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on("change", "#alter_ticket_price_out_inc_mva", function (e) {
      e.preventDefault();
      alterPriceOutIncMva = formattedValueForNumberInput($(this).val());
      const payload = {
        field: "alter_ticket_price_out_inc_mva",
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-alter-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateAlterInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    $(document).on("change", "#alter_vat_code", function (e) {
      e.preventDefault();
      isProductTotalSum = $("#is_product_total_sum").is(":checked");

      alterMva = $(this).children("option:selected").text();
      const payload = {
        field: "alter_price_out_ex_mva",
        alterProductPrice,
        alterPriceOutExMva,
        alterPriceOutIncMva,
        alterDegreeOfCoverage,
        alterCoverageOfContribution,
        alterMva: parseInt(alterMva),
      };

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-alter-price",
        data: payload,
        async: true,
        cache: false,
      })
        .done(function (data) {
          updateAlterInputValues(data);
        })
        .fail(function (data) {
          console.log(data);
        });
    });

    // end of alternative_prices

    $("#menu-product-table-body")
      .children()
      .each(function () {
        const productId = $(this).find(".amount-input").data("product-id"); // Extract product ID from the ID attribute
        const amount = $(this).find(".amount-input").val(); // Get the value of amount input
        const productVolume =
          $(this).find(".amount-input").data("menu-product-volume") || 0;
        const isProductVolume = $(this)
          .find(".amount-input")
          .data("is-menu-product-volume");
        const menuProductPriceExVat = $(this)
          .find(".amount-input")
          .data("ticket-price-exvat");
        // Create an object with product_id and amount and push it to menuProducts array
        menuProducts.push({
          product_id: productId,
          amount: amount,
          product_price_ex_vat: menuProductPriceExVat,
          volume: productVolume,
          is_volume: isProductVolume === "L" ? true : false,
        });
      });

    $(document).on("submit", "#choose-product-search-form", function (e) {
      e.preventDefault();
      let search_string = $("#choose_product_search_string").val();
      let location_id = $("body").attr("event_id");
      let product_type = 0;

      getProductList(location_id, search_string, product_type);
    });

    function updateTicketPriceFromMenuProducts() {
      if ($("#is_product_total_sum").is(":checked")) {
        menuProducts.forEach(function (menuProduct) {
          const ticketPriceExVatForMenuProduct =
            parseFloat(
              $("#ticket_price_ex_vat").val().toString().replace(",", ".")
            ) || 0;
          // console.log("ProductPrice (updateTicketPriceFromMenuProducts):", ticketPriceExVatForMenuProduct);

          if (ticketPriceExVatForMenuProduct > 0) {
            let productPrice;

            if (menuProduct.is_volume) {
              const previousVolume = floorTo2(
                menuProduct.product_price_ex_vat / menuProduct.volume
              );
              productPrice = menuProduct.amount * previousVolume;
            } else {
              productPrice =
                menuProduct.amount * menuProduct.product_price_ex_vat;
            }

            // Apply proper rounding to avoid floating point precision errors
            const existingProductPriceForMenuProduct =
              ticketPriceExVatForMenuProduct - productPrice;
            // existingProductPriceForMenuProduct = Math.round(rawResult * 100) / 100;

            // console.log("Subtraction:", ticketPriceExVatForMenuProduct, "-", productPrice, "=", rawResult);
            // console.log("Rounded result:", parseFloat(existingProductPriceForMenuProduct));
            window.detectedBasePrice = parseFloat(existingProductPriceForMenuProduct);
            $("#ticket_price_ex_vat").val(
              existingProductPriceForMenuProduct.toFixed(2).replace(".", ",")
            );
          }
        });
      }
    }

    $(document).on("click", ".menu-product-item", function () {
      updateTicketPriceFromMenuProducts();

      isProductTotalSum = $("#is_product_total_sum").is(":checked");
      const productName = $(this).data("menu-product-name");
      const productId = $(this).attr("id");
      const productVolume = $(this).data("menu-product-volume");
      const productPriceExVat = $(this).data("ticket-price-exvat");
      const isProductVolume = $(this).data("is-menu-product-volume");
      const tableBody = $("#menu-product-table-body");

      // console.log("Product ID:", productId);
      // console.log("Looking for existing row with ID:", `menu-product-${productId}`);

      // Check if product already exists in the table
      const existingRow = $(`#menu-product-${productId}`);
      // console.log("Existing row found:", existingRow.length > 0);

      if (existingRow.length > 0) {
        // Update the menuProducts array - find by product_id and update amount
        const existingProductIndex = menuProducts.findIndex(
          (p) => p.product_id == parseInt(productId)
        );
        // Product already exists, update the amount
        const amountInput = existingRow.find(".amount-input");
        const currentAmount =
          parseFloat(amountInput.val().replace(",", ".")) || 0;
        const newAmount = currentAmount + 1;
        if (productVolume < newAmount && isProductVolume == "L") {
          alert("Maksimal mengde for denne varen er " + productVolume + " L");
          amountInput.val(currentAmount);
          if (existingProductIndex !== -1) {
            menuProducts[existingProductIndex].amount = currentAmount;
          }
        } else {
          amountInput.val(newAmount);
          if (existingProductIndex !== -1) {
            menuProducts[existingProductIndex].amount = newAmount;
          }
        }
        $("#choose-product-modal").modal("hide");
        if (isProductTotalSum) {
          previousMenuProductTotal = 0;
          // console.log("Adding Products" + menuProducts);
          calculateMenuProductTotalSum(menuProducts);
        }
      } else {
        // Product doesn't exist, add new row
        const menuProduct = {
          product_id: productId,
          name: productName,
          amount: isProductVolume == "L" ? productVolume : 1,
          product_price_ex_vat: productPriceExVat,
          volume: productVolume,
          is_volume: isProductVolume === "L" ? true : false,
        };

        const newRow = `
              <tr id="menu-product-${productId}">
                  <td class="name-column">${productName}</td>
                  <td>
                      <div class="input-group">
                          <input type="number" data-product-id="${productId}" data-menu-product-volume="${productVolume}" data-is-menu-product-volume="${isProductVolume}" class="form-control amount-input" value="${isProductVolume == "L" ? productVolume : 1
          }" min="0" step="any"
                              onfocus="this.select()">
                          <div class="input-group-append">
                              <span class="input-group-text">${isProductVolume}</span>
                          </div>
                      </div>
                  </td>
                  <td class="text-center">
                      <button type="button" data-menu-product-id="${productId}" class="btn btn-danger btn-sm remove-menu-product">${language === "no" ? "Fjerne" : "Remove"
          }</button>
                  </td>
              </tr>
          `;

        tableBody.append(newRow);
        menuProducts.push(menuProduct);
        $("#choose-product-modal").modal("hide");
        if (isProductTotalSum) {
          previousMenuProductTotal = 0;
          // console.log("Adding Products" + menuProducts);
          calculateMenuProductTotalSum(menuProducts);
        } else {
          $(".remove-menu-product").addClass("disabled").prop("disabled", true);
          $(".amount-input").addClass("disabled").prop("disabled", true);
        }
      }
    });

    $(document).on(
      "input",
      "#product-discount-price-input, #product-discount-percent-input, #discount-percent-input",
      function () {
        if (this.value.length > 1 && this.value.indexOf(0) == 0) {
          $(this).val(Math.abs(this.value));
        }
      }
    );

    $(document).on(
      "keydown",
      "#product-discount-price-input, #discount-percent-input, #product-discount-percent-input",
      function (event) {
        if (event.key === "-") {
          event.preventDefault();
        }
      }
    );

    $(document).on("change", ".amount-input", function () {
      updateTicketPriceFromMenuProducts();
      let value = parseFloat(this.value) || 0;
      const productId = $(this).data("product-id");
      const productVolume = $(this).data("menu-product-volume");
      const isProductVolume = $(this).data("is-menu-product-volume");
      isProductTotalSum = $("#is_product_total_sum").is(":checked");
      let wasvolumeValueAdjusted = false;
      if (isProductVolume === "L") {
        if (value > productVolume) {
          alert("Maksimal mengde for denne varen er " + productVolume + " L");
          value = productVolume;
          wasvolumeValueAdjusted = true;
        } else if (value <= 0) {
          alert("Mengden bør være større enn null!");
          value = 0.1;
        }
        $(this).val(value);
      } else {
        if (value <= 0) {
          alert("Mengden bør være større enn null!");
          value = 0.1;
        }
        $(this).val(value);
      }
      const index = menuProducts.findIndex(
        (product) => product.product_id == productId
      );

      if (index !== -1) {
        menuProducts[index].amount = value;
        if (menuProducts[index].is_volume) {
          if (wasvolumeValueAdjusted && value === productVolume) {
            menuProducts[index].isMaxVolume = true;
          } else {
            menuProducts[index].isMaxVolume = false;
          }
        }
      }

      if (isProductTotalSum) {
        previousMenuProductTotal = 0;
        calculateMenuProductTotalSum(menuProducts);
      }
    });

    $(document).on("click", ".remove-menu-product", function (e) {
      e.preventDefault();
      isRemovingPreviousMenuProduct = true;
      const productId = $(this).data("menu-product-id");
      isProductTotalSum = $("#is_product_total_sum").is(":checked");
      $(this).closest("tr").remove();

      const index = menuProducts.findIndex(
        (product) => product.product_id == productId
      );

      if (index !== -1) {
        // console.log("Removing product at index:", menuProducts[index]);
        const ticketPriceExVatForMenuProduct =
          parseFloat($("#ticket_price_ex_vat").val().replace(",", ".")) || 0;
        if (ticketPriceExVatForMenuProduct > 0) {
          if (menuProducts[index].is_volume) {
            // console.log("Menu(Product price ex vat" + menuProducts[index]);
            const previousVolumeAmount = floorTo2(
              menuProducts[index].amount *
              (menuProducts[index].product_price_ex_vat /
                menuProducts[index].volume)
            );
            // console.log("Previous Volume Amount" + previousVolumeAmount);
            // console.log("Current Price" + ticketPriceExVatForMenuProduct);

            existingProductPriceForMenuProduct =
              ticketPriceExVatForMenuProduct - previousVolumeAmount;
            // console.log("Removing Value after Volume" + existingProductPriceForMenuProduct);
          } else {
            const previousStkAmount =
              menuProducts[index].amount *
              menuProducts[index].product_price_ex_vat;
            // alert(ticketPriceExVatForMenuProduct + " - " + (menuProducts[index].amount * menuProducts[index].product_price_ex_vat));
            existingProductPriceForMenuProduct =
              ticketPriceExVatForMenuProduct - previousStkAmount;
            // console.log("Removing Value after Stk" + existingProductPriceForMenuProduct);
          }
        }
        menuProducts.splice(index, 1);
      }
      if (isProductTotalSum) {
        if (menuProducts.length === 0) {
          updateInputValues(
            { productPrice: existingProductPriceForMenuProduct },
            "menu_product_update"
          );
        } else {
          previousMenuProductTotal = 0;
          calculateMenuProductTotalSum(menuProducts);
        }
      }
    });

    $(document).on("change", "#is_menu_product", function () {
      if ($(this).is(":checked")) {
        $("#choose-product-button").show();
      } else {
        $("#choose-product-button").hide();
      }
    });

    if (
      $("#event_ticket_category_id").val() !== undefined &&
      $("#event_ticket_category_id").val() != null &&
      $("#event_ticket_category_id").val() !== ""
    ) {
      $(document).on("submit", "#event_ticket_category_form", function () {
        isProductTotalSum = $("#is_product_total_sum").is(":checked");
        if (!event_ticket_category_update_ajax_lock) {
          let event_id = $("#event_id").val();
          let product_type = parseInt($("#product_type").val());

          event_ticket_category_update_ajax_lock = true;

          $(":disabled").each(function () {
            $(this).removeAttr("disabled");
          });

          let formData = new FormData(
            document.getElementById("event_ticket_category_form")
          );
          let productCategoryPOSIds = formData.getAll("product-category-pos");
          let productCategorySelfServiceIds = formData.getAll(
            "product-category-self-service"
          );
          if (productCategoryPOSIds.length > 0) {
            formData.append("product_category_pos_list", productCategoryPOSIds);
          }
          if (productCategorySelfServiceIds.length > 0) {
            formData.append(
              "product_category_self_service_list",
              productCategorySelfServiceIds
            );
          }

          if (menuProducts.length > 0) {
            formData.append("menu_products", JSON.stringify(menuProducts));
          }

          formData.append("is_product_total_sum", isProductTotalSum ? 1 : 0);

          const disabledOnClick = $(event_ticket_category_button);
          const btnWidth = disabledOnClick.outerWidth();
          disabledOnClick.css("width", btnWidth + "px");

          disabledOnClick.prop("disabled", true);
          disabledOnClick.html(
            '<i class="spinner-border spinner-border-sm"></i>'
          );

          $.ajax({
            type: "POST",
            url: "/ajax/organizer_event_ticket_category/update",
            data: formData,
            enctype: "multipart/form-data",
            async: true,
            cache: false,
            processData: false,
            contentType: false,
          })
            .done(function (data) {
              disabledOnClick.prop("disabled", false);
              disabledOnClick.html("Lagre");
              if (data.message !== undefined && data.message !== null) {
                prependAlert(
                  "#product_msg",
                  data.message,
                  "success",
                  null,
                  "#event_ticket_category_form"
                );
                $(".card-box-to-hide").hide();
                $("#event_ticket_category_button").hide();

                const params = new URLSearchParams(window.location.search);
                const page = params.get("page");

                setTimeout(function () {
                  if (product_type == 0 || product_type == 2) {
                    document.location.href =
                      "/location/" +
                      event_id +
                      "/product" +
                      (page ? "?page=" + page : "");
                  } else {
                    document.location.href =
                      "/location/" +
                      event_id +
                      "/product/extra" +
                      (page ? "?page=" + page : "");
                  }
                }, 2000);
              }
              if (
                data.error &&
                data.message !== undefined &&
                data.message !== null
              ) {
                prependAlert("#product_msg", data.message, "danger", null);
              }
            })
            .fail(function (data) {
              disabledOnClick.prop("disabled", false);
              disabledOnClick.html("Lagre");
              if (
                data.responseJSON.redirect_url !== undefined &&
                data.responseJSON.redirect_url !== null
              ) {
                document.location.href = data.responseJSON.redirect_url;
              }

              if (
                data.responseJSON.error_message !== undefined &&
                data.responseJSON.error_message !== null
              ) {
                prependAlert(
                  "#product_msg",
                  data.responseJSON.error_message,
                  "danger",
                  null,
                  "#event_ticket_category_form"
                );
              }

              event_ticket_category_update_ajax_lock = false;
            })
            .always(function () {
              event_ticket_category_update_ajax_lock = false;
            });
        }

        return false;
      });
    }

    function getProductList(location_id, search_string, product_type) {
      $.ajax({
        type: "POST",
        url: "/ajax/organizer_event_ticket_category/menu_product_search",
        data: {
          location_id,
          search_string,
          product_type,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $("#choose-product-list-container").empty();
            $("#choose-product-list-container").append(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function updateAlterInputValues(data) {
      if (
        data.alterProductPrice !== undefined &&
        data.alterProductPrice !== null &&
        data.alterPriceOutExMva !== undefined &&
        data.alterPriceOutExMva !== null &&
        data.alterPriceOutIncMva !== undefined &&
        data.alterPriceOutIncMva !== null &&
        data.alterDegreeOfCoverage !== undefined &&
        data.alterDegreeOfCoverage !== null &&
        data.alterCoverageOfContribution !== undefined &&
        data.alterCoverageOfContribution !== null &&
        data.alterMva !== undefined &&
        data.alterMva !== null
      ) {
        alterProductPrice = data.alterProductPrice;
        alterPriceOutExMva = data.alterPriceOutExMva;
        alterPriceOutIncMva = data.alterPriceOutIncMva;
        alterDegreeOfCoverage = data.alterDegreeOfCoverage;
        alterCoverageOfContribution = data.alterCoverageOfContribution;
        alterMva = data.alterMva;

        $("#alter_coverage_contribution").val(
          data.alterCoverageOfContribution.toString().replace(".", ",")
        );
        $("#alter_price_out_ex_mva").val(
          data.alterPriceOutExMva.toString().replace(".", ",")
        );
        $("#alter_ticket_price_out_inc_mva").val(
          data.alterPriceOutIncMva.toString().replace(".", ",")
        );
        $("#ticket_alter_price_ex_vat").val(
          data.alterProductPrice.toString().replace(".", ",")
        );
        $("#alter_degree_of_coverage").val(
          data.alterDegreeOfCoverage.toString().replace(".", ",")
        );
        $("#alter_vat_code option").each(function () {
          console.log("Option text:", $(this).text());

          if ($(this).text() == alterMva) {
            $(this).prop("selected", true);
            $("#alter_vat_code").trigger("change");
          }
        });
      }
    }

    function clearAlterInputValues() {
      // Clear the values of the relevant input fields
      $("#ticket_alter_price_ex_vat").val("");
      $("#alter_degree_of_coverage").val("");
      $("#alter_coverage_contribution").val("");
      $("#alter_price_out_ex_mva").val("");
      $("#alter_ticket_price_out_inc_mva").val("");
      $("#alter_vat_code").val("");
    }
    $(document).on("change", "#alternative_price", function (e) {
      if (!$(this).is(":checked")) {
        clearAlterInputValues();
      }
    });

    function calculateMenuProductTotalSum(menuProducts = [], type, callback) {
      console.log(
        "Calculating menu product total sum with type:",
        JSON.stringify(menuProducts)
      );
      if (menuProducts.length === 0) {
        updateInputValues(
          { productPrice: productPrice },
          "menu_product_update"
        );
        if (callback) callback(0);
        return;
      }

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/calculate-menu-prodcut-price",
        data: { menuProducts },
        async: true,
        cache: false,
      })
        .done(function (data) {
          // console.log("called menu-pro-price-api", JSON.stringify(data));
          if (
            type !== undefined &&
            type !== null &&
            type === "get_current_total_menu_product_price"
          ) {
            if (callback) callback(data.totalProductPrice);
            return;
          }
          updateInputValues(data, "menu_product_update");
        })
        .fail(function (data) {
          // console.log(data);
          if (callback) callback(0);
        });
    }

    function updateInputValues(data, type) {
      //old-initial-price + final-menu-product-price
      if (type !== null && type !== "" && type === "menu_product_update") {
        if (!isRemovingPreviousMenuProduct) {
          const menuProductPrice = data.totalProductPrice || 0;
          // console.log("existingOldProductPrice (data-old-value):", existingOldProductPrice);
          // console.log("menuProductPrice (API):", menuProductPrice);

          let basePrice;

          // Check if we've already determined the base price in a previous call
          if (typeof window.detectedBasePrice === "undefined") {
            // First time - detect if original base price was 0
            if (Math.abs(menuProductPrice - existingOldProductPrice) < 0.01) {
              window.detectedBasePrice = 0;
              // console.log("First detection: Original base price was 0 (menu total matches data-old-value)");
            } else {
              // Calculate the actual base price on first detection
              window.detectedBasePrice =
                existingOldProductPrice - menuProductPrice;
              // console.log("First detection: Original base price was", window.detectedBasePrice);

              // Safety check
              if (window.detectedBasePrice < 0) {
                console.warn(
                  "Calculated base price is negative, defaulting to 0"
                );
                window.detectedBasePrice = 0;
              }
            }
          }

          // Always use the detected base price from the first calculation
          basePrice = window.detectedBasePrice;
          // console.log("Using stored basePrice:", basePrice);

          const newItemsPrice = menuProductPrice - previousMenuProductTotal;
          // console.log("newItemsPrice:", newItemsPrice);

          previousMenuProductTotal = menuProductPrice;
          // console.log("previousMenuProductTotal:", previousMenuProductTotal);
          // console.log(basePrice + " + " + parseFloat(newItemsPrice));

          const newMenuProductPrice = basePrice + parseFloat(newItemsPrice);
          // console.log("newMenuProductPrice:", newMenuProductPrice);

          const formattedPrice = newMenuProductPrice
            .toFixed(2)
            .replace(".", ",");
          // console.log("formattedPrice:", formattedPrice);

          $("#ticket_price_ex_vat").val(formattedPrice);
          productPrice = newMenuProductPrice.toFixed(2);
          // console.log("ProductPrice:", productPrice);

          if (
            degreeOfCoverage === null ||
            degreeOfCoverage === undefined ||
            degreeOfCoverage === ""
          ) {
            degreeOfCoverage = 0;
          }
          $("#degree_of_coverage").trigger("change");
        } else {
          const formattedPrice = existingProductPriceForMenuProduct
            .toFixed(2)
            .replace(".", ",");
          // console.log("formattedPrice:", formattedPrice);
          $("#ticket_price_ex_vat").val(formattedPrice);
          // console.log("formattedPrice for calculation APi:", existingProductPriceForMenuProduct.toFixed(2));
          productPrice = existingProductPriceForMenuProduct.toFixed(2);
          if (
            degreeOfCoverage === null ||
            degreeOfCoverage === undefined ||
            degreeOfCoverage === ""
          ) {
            degreeOfCoverage = 0;
          }
          $("#degree_of_coverage").trigger("change");
        }
        return;
      }
      isRemovingPreviousMenuProduct = false;

      if (
        data.productPrice !== undefined &&
        data.productPrice !== null &&
        data.priceExMva !== undefined &&
        data.priceExMva !== null &&
        data.priceIncMva !== undefined &&
        data.priceIncMva !== null &&
        data.degreeOfCoverage !== undefined &&
        data.degreeOfCoverage !== null &&
        data.coverageOfContribution !== undefined &&
        data.coverageOfContribution !== null &&
        data.mva !== undefined &&
        data.mva !== null
      ) {
        priceExMva = data.priceExMva;
        priceIncMva = data.priceIncMva;
        degreeOfCoverage = data.degreeOfCoverage;
        coverageOfContribution = data.coverageOfContribution;
        mva = data.mva;
        productPrice = data.productPrice;
        $("#coverage_contribution").val(
          data.coverageOfContribution.toString().replace(".", ",")
        );
        $("#price-ex-mva-value").val(
          data.priceExMva.toString().replace(".", ",")
        );
        $("#price-inc-mva-value").val(
          data.priceIncMva.toString().replace(".", ",")
        );
        $("#ticket_price_ex_vat").val(
          data.productPrice.toString().replace(".", ",")
        );
        $("#degree_of_coverage").val(
          data.degreeOfCoverage.toString().replace(".", ",")
        );

        $("#vat_code option").each(function () {
          if ($(this).text() == mva) {
            $(this).prop("selected", true);
            $("#vat_code").trigger("change");
          }
        });
      }
    }
  }
});
